import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatsCardProps {
  icon: LucideIcon;
  value: number;
  label: string;
  iconColor?: string;
}

export default function StatsCard({ icon: Icon, value, label, iconColor = 'text-purple-400' }: StatsCardProps) {
  return (
    <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/20">
      <div className="flex items-center justify-between mb-4">
        <Icon className={`w-8 h-8 ${iconColor}`} />
        <span className="text-3xl font-bold text-white">{value}</span>
      </div>
      <h3 className="text-gray-400 text-sm">{label}</h3>
    </div>
  );
}
